import { render, staticRenderFns } from "./LocalesTree.vue?vue&type=template&id=0c90709a&scoped=true"
import script from "./LocalesTree.vue?vue&type=script&lang=js"
export * from "./LocalesTree.vue?vue&type=script&lang=js"
import style0 from "./LocalesTree.vue?vue&type=style&index=0&id=0c90709a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c90709a",
  null
  
)

export default component.exports